import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label mb-1" }, "DME Vendor", -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "ms-3 mt-3 card card-body p-3"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<p><span class=\"shimmer-loading block-size-6\"></span></p><p><span class=\"shimmer-loading block-size-4\"></span></p><p><span class=\"shimmer-loading block-size-8\"></span></p><p><span class=\"shimmer-loading block-size-6\"></span></p><p><span class=\"shimmer-loading block-size-4\"></span></p>", 5)
const _hoisted_9 = [
  _hoisted_4
]
const _hoisted_10 = {
  key: 1,
  class: "mt-2 card p-2 d-flex flex-column"
}
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = { class: "d-flex mb-1" }
const _hoisted_13 = { class: "d-flex mb-1" }
const _hoisted_14 = { class: "me-1" }
const _hoisted_15 = {
  key: 0,
  class: "me-1"
}
const _hoisted_16 = { class: "me-1" }
const _hoisted_17 = { class: "me-1" }
const _hoisted_18 = { class: "me-1" }
const _hoisted_19 = {
  key: 0,
  class: "d-flex mb-1"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("strong", null, "Phone:", -1 /* HOISTED */)
const _hoisted_21 = {
  key: 1,
  class: "text-default"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("strong", null, "Fax:", -1 /* HOISTED */)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", {
  else: "",
  class: "text-default"
}, "Not Available", -1 /* HOISTED */)
const _hoisted_24 = {
  key: 1,
  class: "d-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_FormatName = _resolveComponent("FormatName")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_TypeaheadInput, {
      getData: _ctx.getVendorList,
      value: _ctx.vendor,
      placeholder: "Start Typing...",
      "character-limit": 3,
      onValueChanged: _ctx.vendorChanged
    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged"]),
    (_ctx.loadingVendorDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_9))
      : _createCommentVNode("v-if", true),
    (!_ctx.loadingVendorDetails && _ctx.vendorDetails.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.vendorDetails.name), 1 /* TEXT */),
          _createElementVNode("section", _hoisted_12, [
            _createVNode(_component_FormatName, {
              "first-name": _ctx.vendorDetails.contactFirstName,
              "last-name": _ctx.vendorDetails.contactLastName
            }, null, 8 /* PROPS */, ["first-name", "last-name"])
          ]),
          _createElementVNode("section", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.vendorDetails.address.addressLine1) + ",", 1 /* TEXT */),
            (_ctx.vendorDetails.address.addressLine2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.vendorDetails.address.addressLine2) + ", ", 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.vendorDetails.address.city) + ",", 1 /* TEXT */),
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.vendorDetails.address.state), 1 /* TEXT */),
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.formatZipCode(_ctx.vendorDetails.address.zipCode)), 1 /* TEXT */)
          ]),
          (_ctx.vendorDetails.primaryPhone)
            ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
                _createElementVNode("span", null, [
                  _hoisted_20,
                  (!!_ctx.vendorDetails.primaryPhone.number)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.formatPhoneNumber(_ctx.vendorDetails.primaryPhone.number)) + " ", 1 /* TEXT */),
                        (!!_ctx.vendorDetails.primaryPhone.extension)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" Extn: " + _toDisplayString(_ctx.vendorDetails.primaryPhone.extension), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock("i", _hoisted_21, "Not Available"))
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("section", null, [
            _createElementVNode("span", null, [
              _hoisted_22,
              (!!_ctx.vendorDetails.faxNumber)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.formatPhoneNumber(_ctx.vendorDetails.faxNumber)), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _hoisted_23
            ])
          ]),
          (_ctx.vendorDetails.email)
            ? (_openBlock(), _createElementBlock("section", _hoisted_24, [
                _createElementVNode("span", null, _toDisplayString(_ctx.vendorDetails.email), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}